import axios from "@/helpers/axios";

const USERS_URL = "/users/";
const CLIENTS_URL = "/users/";
const ORDERS_URL = "/orders/";
const CONFIG_URL = "/config/";
const LOCATIONS_URL = "/locations/";
const GEOCODE_URL = "/geocode/";

export default {
  initializeStore({ state }) {
    if (localStorage.getItem("vuex3")) {
      try {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem("vuex3")))
        );
        localStorage.removeItem("vuex");
        localStorage.removeItem("vuex2");
      } catch (error) {
        console.error(`error on replaceState`); // eslint-disable-line
        console.error(error); // eslint-disable-line
      }
    }
  },

  async checkId({}, payload) {
    try {
      const result = await axios({
        method: "get",
        url: `${USERS_URL}biz/userId/${payload}`,
        headers: {
          bypass: true,
        },
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async biz_master_signup({}, payload) {
    try {
      const result = await axios({
        method: "post",
        url: `${USERS_URL}biz-manager`,
        data: payload,
        headers: {
          bypass: true,
        },
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_manager_myInfo({ state }) {
    try {
      const result = await axios({
        method: "get",
        url: `${USERS_URL}biz-manager/my-information?v=2`,
        headers: {
          Authorization: state.auth.accessToken,
        },
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async biz_member_find_manager({}, payload) {
    try {
      const result = await axios({
        method: "post",
        url: `${USERS_URL}biz-manager/exist/company-name`,
        data: payload,
        headers: {
          bypass: true,
        },
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async biz_member_signup({ commit, state }, payload) {
    try {
      const result = await axios({
        method: "post",
        url: `${USERS_URL}biz-member`,
        data: payload,
        headers: {
          bypass: true,
        },
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async api_get_config({ state }) {
    let config = null;
    try {
      config = await axios.get(`${CONFIG_URL}`);
    } catch (error) {
      alert(error);
    }
    return config.data.config;
  },

  async api_get_orderDetail({ state }, orderId) {
    let order = null;
    try {
      order = await axios.get(`${ORDERS_URL}clients/${orderId}`, {
        headers: { Authorization: state.auth.accessToken },
      });
    } catch (error) {
      alert(error);
    }
    return order.data;
  },

  async api_get_myOrders({ commit, dispatch }, page) {
    let orders = null;
    try {
      orders = await axios.get(
        `${ORDERS_URL}clients/my?perPage=5&currentPage=${page}`,
        { headers: { Authorization: state.auth.accessToken } }
      );
      console.error(orders);
    } catch (error) {
      console.error(error);
      alert(error);
    }
    return orders;
  },

  async api_get_riderInfo({ dispatch }, payload) {
    const apiUrl = `${CLIENTS_URL}riderInfo/by-orderId/${payload}`;
    try {
      const riderInformations = await axios({
        url: apiUrl,
        headers: { Authorization: state.auth.accessToken },
      });
      return riderInformations.data;
    } catch (error) {
      throw error;
    }
  },

  async api_cancelOrder({ state, dispatch }, payload) {
    try {
      const insertResult = await axios.post(`${ORDERS_URL}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: state.auth.accessToken,
        },
      });
      return insertResult;
    } catch (error) {
      alert(error);
    }
  },

  async api_post_insertOrders({ state, dispatch }, payload) {
    try {
      const insertResult = await axios.post(ORDERS_URL, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: state.auth.accessToken,
        },
      });
      return insertResult;
    } catch (error) {
      alert(error);
    }
  },

  async search_address({}, payload) {
    try {
      const result = await axios.post(GEOCODE_URL, {
        query: payload,
      });

      // ms-geocode 내부의 naverAPI 에러
      if (result.data.success !== true) {
        return { serverError: true };
      }

      return result.data.searchResult;
    } catch (error) {
      return { serverError: true };
    }
  },

  async api_get_riderLocations({ dispatch }, payload) {
    try {
      const riderLocations = await axios.get(`${LOCATIONS_URL}${payload}`, {
        headers: { Authorization: state.auth.accessToken },
      });
      if (riderLocations.data.success !== true) {
        this.signout();
        return this.$router.push("/");
      }

      return riderLocations.data.coords;
    } catch (error) {
      throw error;
    }
  },
  setUrgentModalVisible({ commit }, payload) {
    commit("urgentWeatherModal", payload);
  },

  setPopupModalVisible({ commit }, payload) {
    commit("popupModalSwitch", payload);
  },
};
